import { themeVariables } from "Components/theme";
import { WebGL2Effect, WebGL2IconNodeStyle, WebGL2ShapeNodeShape } from "yfiles";
import { NODE_DEFAULT_SIZE } from "../../constants";
import buildStroke from "./buildStroke";
const webGL2NodeStyles = {
    iconIdMap: {
        _default: {
            _default: new WebGL2IconNodeStyle({
                icon: new ImageData(NODE_DEFAULT_SIZE.width, NODE_DEFAULT_SIZE.height),
                shape: WebGL2ShapeNodeShape.ELLIPSE,
                fill: "#ffffff",
                stroke: buildStroke(themeVariables["gray-500"], false),
                effect: WebGL2Effect.NONE
            }),
            _defaultSelected: new WebGL2IconNodeStyle({
                icon: new ImageData(NODE_DEFAULT_SIZE.width, NODE_DEFAULT_SIZE.height),
                shape: WebGL2ShapeNodeShape.ELLIPSE,
                fill: themeVariables["brand-primary-200"],
                stroke: buildStroke(themeVariables["brand-primary-500"], true),
                effect: WebGL2Effect.NONE
            })
        }
    },
    nodeIdMap: {}
};
export default webGL2NodeStyles;
